var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-block w-2/4 button-blue-light text-white rounded pk-bg-blue-100",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(_vm._s(_vm.$t('text.further_information'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }